import axios from 'axios';

import { getAuthorizationHeader } from '../utils/getAuthHeader';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}`;
const url = `${API_URL}/ticket-permission`;

export async function addMultipleUsersPermissions({
  ticketId,
  userIds,
  isReadPermission,
  isWritePermission,
}) {
  const cleanId = String(ticketId);
  const permissions = [isReadPermission, isWritePermission];
  const response = await axios.post(
    `${url}/${cleanId}/multiple`,
    { userIds, permissions },
    { headers: getAuthorizationHeader() }
  );
  return response.data;
}

export async function deleteUserPermission({ ticketId, userId }) {
  const cleanTicketId = String(ticketId);
  const cleanUserId = String(userId);
  const response = await axios.delete(`${url}/${cleanTicketId}/users/${cleanUserId}`, {
    headers: getAuthorizationHeader(),
  });
  return response;
}

export async function updateUserPermissions({
  ticketId,
  userId,
  isReadPermission,
  isWritePermission,
}) {
  const cleanTicketId = String(ticketId);
  const cleanUserId = String(userId);
  if (isWritePermission) isReadPermission = true;
  const newPermissions = [isReadPermission, isWritePermission];
  const response = await axios.put(
    `${url}/${cleanTicketId}/users/${cleanUserId}`,
    newPermissions,
    { headers: getAuthorizationHeader() }
  );
  return response.data;
}

export async function fetchUsersWithPermissions(ticketId) {
  const cleanId = String(ticketId);
  const response = await axios.get(`${url}/${cleanId}/users`, {
    headers: getAuthorizationHeader(),
  });
  return response.data;
}

export async function fetchUserPermissions(ticketId, userId) {
  const cleanTicketId = String(ticketId);
  const cleanUserId = String(userId);
  const response = await axios.get(`${url}/${cleanTicketId}/users/${cleanUserId}`, {
    headers: getAuthorizationHeader(),
  });
  return response.data;
}

export const getTaggedTickets = async (userId) => {
  const cleanUserId = String(userId);
  const result = await axios.get(`${url}/permission/user/${cleanUserId}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};
